import { type RequestHandler, rest } from 'msw'
import { type EntitlementsResponse } from './types'
import {
  useEntitlementsResponseHasAccess,
  useEntitlementsResponseNoAccess
} from './useEntitlements.responses'

const uri = '/v1/entitlements'

const useStubEntitlements = (response: EntitlementsResponse) => {
  return rest.get(uri, async (_req, res, ctx) => {
    return res(ctx.json<EntitlementsResponse>(response))
  })
}

export const useEntitlementsHandlersHasAccess: RequestHandler[] = [
  useStubEntitlements(useEntitlementsResponseHasAccess)
]

export const useEntitlementsHandlersNoAccess: RequestHandler[] = [
  useStubEntitlements(useEntitlementsResponseNoAccess)
]

export const useEntitlementsHandlersFailure: RequestHandler[] = [
  rest.get(uri, async (_req, res, ctx) => {
    return res(ctx.status(500))
  })
]
